import { useEffect, useState } from 'react';
import { useHistory } from 'react-router-dom';
import ChargerModule from '../../components/chargerModule';
import { getCategories } from '../../services/cataloge';
import { ICategoryList } from '../../types/category';
import { displayErrorNotification } from 'utils/displayNudosStandardNotifications';
import ChooseType from './ChooseType';
import './CategoryType.scss';

interface IProductType {
  id: number;
  type: string;
}

const CategoryType = () => {
  const { push } = useHistory();
  const headerInfo = { title: 'Catalogo', titleRoute: '/catalog/product-list', subtitle: 'Nuevo producto' };
  const infoSideBar = { position: 'catalog' };
  const [productType, setProductType] = useState<IProductType>({ id: 0, type: '' });
  const [loading, setLoading] = useState<boolean>(false);
  const [categoryList, setCategoryList] = useState<ICategoryList>();

  const handleChangeType = (option: IProductType) => {
    setProductType(option);
    push(`/catalog/create-product/${option.id}`);
  };

  const getCategoryList = async () => {
    setLoading(true);
    try {
      const dataCategoryList = await getCategories();
      setCategoryList(dataCategoryList);
      setLoading(false);
    } catch (error) {
      setLoading(false);
      displayErrorNotification();
    }
  };
  useEffect(() => {
    getCategoryList();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <ChargerModule headerInfo={headerInfo} infoSideBar={infoSideBar}>
      <div id="categoryTypeModule">
        <ChooseType loading={loading} list={categoryList} handleChangeType={handleChangeType} value={productType} />
      </div>
    </ChargerModule>
  );
};

export default CategoryType;
